// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3EUHc","title":"Header_title__K0iUV","side":"Header_side__3Rh3J"};